import React from 'react';
import { ShieldIcon } from 'lucide-react';
interface DmpLogoProps {
  size?: number;
  tone?: 'light' | 'dark';
}

/** Clearly marked placeholder for the official DMP / Bangladesh Police logo. Replace with the supplied asset. */
export function DmpLogo({
  size = 40,
  tone = 'dark'
}: DmpLogoProps) {
  const light = tone === 'light';
  return <div title="ডিএমপি লোগো — অফিসিয়াল লোগো আপলোডের স্থান" aria-label="ডিএমপি লোগো স্থান" role="img" className={`relative shrink-0 rounded-full border-2 border-dashed flex flex-col items-center justify-center ${light ? 'border-white/60 bg-white/10 text-white' : 'border-navy/50 bg-navy-50 text-navy'}`} style={{
    width: size,
    height: size
  }} data-id="element-101" data-mp="3rhxtp55ayldp">
      <ShieldIcon style={{
      width: size * 0.42,
      height: size * 0.42
    }} strokeWidth={1.8} data-id="element-102" data-mp="38tkg6entkb7x" />
      {size >= 56 && <span className="text-[9px] font-semibold leading-none mt-0.5" data-id="element-103" data-mp="33rv54z0ljxju">লোগো</span>}
    </div>;
}